module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong-13cb8a703b746508380a82ffcb6d3474.png";